module.exports = __webpack_public_path__ + "static/media/CormorantGaramond-Bold.03148ed4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CormorantGaramond-Bold.ttf
// module id = 3139
// module chunks = 70